import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { WSDepartureService } from '../../shared/services/ws-departure-service/implementations/ws-departure.service';

export const authGuard: CanActivateFn = () => {
  const token: string | null = localStorage.getItem('rsToken');
  const router: Router = inject(Router);
  const wsService: WSDepartureService = inject(WSDepartureService);

  if (!token) {
    wsService.unsubscribeCentrifuge();
    return router.createUrlTree(['/auth']);
  }
  wsService.canConnectToCentrifugeController.next(true);
  return true;
};
